import { selectNow } from "app/TimeSlice";
import { DateTime } from "luxon";
import { useSelector } from "react-redux";

const useTimeNow = () => DateTime.fromISO(useSelector(selectNow));
export default useTimeNow;